import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { Card, Box } from '@material-ui/core';
import CurrentPasswordRecoveryStep from 'containers/PasswordRecoveryPages/CurrentPasswordRecoveryStep';
import {
  useLayoutStyles,
  StyledWrapper,
} from 'containers/PasswordRecoveryPages/styles';
import {
  getPasswordCurrentRecoveryStepNameSelector,
  getIsLoadingSelector,
} from 'store/credentials/selectors';
import {
  submitPasswordRecoveryStep,
  setPasswordRecoveryStep,
} from 'store/credentials/actions';
import {
  RecoveryPagePropsType,
  RecoveryPageSelectorsType,
} from 'containers/PasswordRecoveryPages/types';
import HeaderRecovery from 'components/HeaderRecovery';
import { translate } from 'helpers/intl';
import messages from 'containers/PasswordRecoveryPages/InsertIdentifiant/messages';

const RecoveryPasswordPage = (props: RecoveryPagePropsType) => {
  const classes = useLayoutStyles();
  const {
    passwordRecoveryStep,
    submitPasswordRecoveryStep,
    setPasswordRecoveryStep,
    isLoading,
  } = props;
  return (
    <StyledWrapper>
      <Box className={classes.box} paddingY={2}>
        <Card className={classes.paper}>
          <HeaderRecovery title={translate({ ...messages.title }, props)} />
          <CurrentPasswordRecoveryStep
            stepName={passwordRecoveryStep}
            onSubmitStep={submitPasswordRecoveryStep}
            isLoading={isLoading}
            setPasswordRecoveryStep={setPasswordRecoveryStep}
            hasAmc={props.location?.state?.hasAmc}
          />
        </Card>
      </Box>
    </StyledWrapper>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  RecoveryPageSelectorsType
>({
  passwordRecoveryStep: getPasswordCurrentRecoveryStepNameSelector,
  isLoading: getIsLoadingSelector,
});

const mapDispatchToProps = {
  submitPasswordRecoveryStep,
  setPasswordRecoveryStep,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RecoveryPasswordPage),
);
